// Write where somebody is into the address, so a reload brings them back to the same tab or dossier.
// replaceState, not navigate: the page is already showing it, and the Back button should not fill up
// with every tab clicked. null removes the key.
export function setUrlParams(patch) {
  const url = new URL(window.location.href)
  for (const [k, v] of Object.entries(patch)) {
    if (v === null || v === undefined || v === '') url.searchParams.delete(k)
    else url.searchParams.set(k, String(v))
  }
  window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash)
}
